import Calendar from './calendar.png';
import PaperclipIcon from './paperclip.png';
import UserIcon from './user.png';
import UserCircleIcon from './menu/user-circle.png';
import LogoutMenuIcon from './menu/logout.png';
import ArrowLeft from './arrow-left.png';
import LockIcon from './lock.png';
import PasswordInactive from './password-inactive.png';
import PasswordActive from './password-active.png';
import LogoutIcon from './logout.png';
import ProfileIcon from './profile.png';
import DownloadIcon from './download.png';
import EditIcon from './edit.png';
import AddIcon from './add.png';
import SearchIcon from './search.png';
import TrashIcon from './trash.png';
import ArrowUp from './arrow-up.png';
import ArrowBottom from './arrow-bottom.png';
import ViewIcon from './view.png';
import MailIcon from './mail.png';
import TimeIcon from './time.png';
import ArrowBottomBlack from './arrow-bottom-black.png';
import ArrowUpBlack from './arrow-up-black.png';
import CalendarWhite from './calendar-white.png';
import DeleteIcon from './delete.png';
import CalendarRed from './calendar-red.png';
import CloseIcon from './close.png';
import CheckGreenIcon from './check-green.png';
import MenuIcon from './menu.png';
import LogoutGray from './logout-gray.png';
import ArrowLeft2 from './arrow-left2.png';
import LocationIcon from './location.png';
import PhoneIcon from './phone.png';
import FacebookIcon from './facebook.png';
import InstagramIcon from './instagram.png';
import WebIcon from './web.png';
import CleanIcon from './clean.png';
import ArrowRight from './arrow-right.png';
import UploadIcon from './upload.png';
import ArrowLeftBlack from './arrow-left-black.png';
import ArrowRightBlack from './arrow-right-black.png';
import CheckWhiteIcon from './check-white.png';
import StarIcon from './star.png';
import StarActiveIcon from './star-active.png';
import XLSIcon from './xls.png';
import DocIcon from './doc.png';
import PdfIcon from './pdf.png';
import Download2Icon from './download2.png';
import EyeBlackIcon from './eye-black.png';
import DownloadBlackIcon from './download-black.png';
import AlertIcon from './alert.png';
import ModeratorIcon from './moderator.png';
import EditBlueIcon from './edit-blue.png';
import PrintIcon from './print.png';
import AssignIcon from './assign.png';
import IconUsers from './icon-users.png';
import UserSettings from './user-settings.png';
import DownloadExcelIcon from './download-excel.png';
import GoogleMapsIcon from './google-maps.png';
import PercentageIcon from './percentage.png';
import BankIcon from './bank.png';
import ListIcon from './list.png';
import PaymentIcon from './payments.png';
import DocumentIcon from './documents.png';
import ChatIcon from './chat.png';
import SendIcon from './send.png';
import UsersIcon from './users.png';
import LawyersIcon from './lawyers.png';
import ModeratorsIcon from './moderators.png';
import UserMembershipIcon from './user-membership.png';
import CloseRedIcon from './close-red.png';
import CheckGreenCircle from './check-green-circle.png';
import LawyerMembershipIcon from './lawyer-membership.png';
import ToggleGreen from './toggle-green.png';
import ToggleRed from './toggle-red.png';
import BackIcon from './back.png';
import Document2Icon from './documents-2.png';
import SurveysIcon from './surveys.png';
import ChatAIIcon from './chat-ai.png';
import Payments2Icon from './payments2.png';
import HistoryIcon from './history.png';
import CallIcon from './call.png';
import FilterIcon from './filter.png';
import CopyIcon from './copy.png';
import AreaIcon from './area.png';
import ClockIcon from './clock.png';
import WarningIcon from './warning.png';
import CommentIcon from './comment.png';
import ImageIcon from './icons-image.png';
import ThreePointsIcon from './three-points.png';
import ReferralWithdrawalIcon from './reicon_wallet-up.svg';
import WalletFilledIcon from './reicon_wallet-3-filled.svg';
import ProfileFillIcon from './iconamoon_profile-fill.svg';
import GiftIcon from './fluent_gift-16-filled.svg';

// Menu
import Menu1 from './menu/menu1.png';
import Menu2 from './menu/menu2.png';
import Menu3 from './menu/menu3.png';
import Menu4 from './menu/menu4.png';
import Menu5 from './menu/menu5.png';
import Menu6 from './menu/menu6.png';
import Menu7 from './menu/menu7.png';
import Menu8 from './menu/menu8.png';
import Menu9 from './menu/menu9.png';
import Menu10 from './menu/menu10.png';
import Menu11 from './menu/menu11.png';
import Menu12 from './menu/menu12.png';
import Menu13 from './menu/menu13.png';
import Menu14 from './menu/menu14.png';
import Menu15 from './menu/menu15.png';
import Menu16 from './comunicado.png';

const Menu = {
  Menu1,
  Menu2,
  Menu3,
  Menu4,
  Menu5,
  Menu6,
  Menu7,
  Menu8,
  Menu9,
  Menu10,
  Menu11,
  Menu12,
  Menu13,
  Menu14,
  Menu15,
  Menu16,
};

export {
  Calendar,
  ArrowLeft,
  PaperclipIcon,
  UserIcon,
  UserCircleIcon,
  LogoutMenuIcon,
  LockIcon,
  PasswordInactive,
  PasswordActive,
  LogoutIcon,
  ProfileIcon,
  DownloadIcon,
  EditIcon,
  AddIcon,
  SearchIcon,
  TrashIcon,
  ArrowUp,
  ArrowBottom,
  ViewIcon,
  MailIcon,
  TimeIcon,
  ArrowBottomBlack,
  ArrowUpBlack,
  CalendarWhite,
  DeleteIcon,
  CalendarRed,
  CloseIcon,
  CheckGreenIcon,
  Menu,
  MenuIcon,
  LogoutGray,
  ArrowLeft2,
  LocationIcon,
  WebIcon,
  InstagramIcon,
  FacebookIcon,
  PhoneIcon,
  CleanIcon,
  ArrowRight,
  UploadIcon,
  ArrowLeftBlack,
  ArrowRightBlack,
  CheckWhiteIcon,
  StarActiveIcon,
  StarIcon,
  XLSIcon,
  Download2Icon,
  EyeBlackIcon,
  DownloadBlackIcon,
  AlertIcon,
  ModeratorIcon,
  EditBlueIcon,
  PrintIcon,
  AssignIcon,
  IconUsers,
  UserSettings,
  DownloadExcelIcon,
  GoogleMapsIcon,
  PercentageIcon,
  BankIcon,
  PaymentIcon,
  ListIcon,
  DocumentIcon,
  ChatIcon,
  SendIcon,
  UsersIcon,
  LawyersIcon,
  ModeratorsIcon,
  UserMembershipIcon,
  LawyerMembershipIcon,
  CloseRedIcon,
  CheckGreenCircle,
  ToggleGreen,
  ToggleRed,
  BackIcon,
  Document2Icon,
  SurveysIcon,
  ChatAIIcon,
  Payments2Icon,
  HistoryIcon,
  CallIcon,
  CopyIcon,
  AreaIcon,
  ClockIcon,
  WarningIcon,
  CommentIcon,
  DocIcon,
  PdfIcon,
  ImageIcon,
  ThreePointsIcon,
  ReferralWithdrawalIcon,
  WalletFilledIcon,
  ProfileFillIcon,
  GiftIcon,
};
